import axios, { withCredentials } from '../util/axiosInstance';
const url = '/learnerserver/state/consented';
export const getStateList = async () => {
    const response = await axios()
        .get(url, withCredentials())
        .then((res)=>res.data.data.map((state:any)=>({id:state?.data?.stateId,title:state?.data?.stateId})));
    return response
};
